<template>
  <div class="list dataset-list">
     <div class="list-data">
         <div class="data" v-for="(val, index) in [1,2]" :key="index">
            <div class="columns-wrapper">
               <div class="tabular-content column-left ph-item">
                  <div class="ph-col-12">
                     <div class="ph-row">
                        <div class="ph-col-12 big"></div>

                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>

                        <div class="ph-col-6"></div>
                        <div class="ph-col-6 empty"></div>

                        <div class="ph-col-2"></div>
                        <div class="ph-col-10 empty"></div>
                        <div class="ph-col-2"></div>
                        <div class="ph-col-10 empty"></div>
                        <div class="ph-col-2"></div>
                        <div class="ph-col-10 empty"></div>
                     </div>
                     <div class="ph-picture"></div>
                  </div>
               </div> <!-- /tabular-content /column-left -->
               <div class="column-right ph-item">
                  <div class="ph-col-12">
                     <div class="ph-picture"></div>
                     <div class="ph-row">
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
     </div>
  </div>
</template>

<script>
export default {
   name: "DatasetList"
}
</script>

<style scoped>
@import 'https://cdn.jsdelivr.net/npm/placeholder-loading/dist/css/placeholder-loading.min.css';

.ph-item {
    padding: 0;
    border: 0;
}
.ph-col-12 {
   padding: 0;
}
</style>